<template>
  <div class="center">
    <div class="title">
      {{ newData.name }}
    </div>
    <div class="zp_details">
      <el-row>
        <el-col :span="16">
          <div class="grid-content bg-purple">
            <el-breadcrumb separator="|">
              <el-breadcrumb-item
                >作者 ：{{ newData.username }}</el-breadcrumb-item
              >
              <el-breadcrumb-item
                >{{ label_name }}：{{ newData.from }}</el-breadcrumb-item
              >
              <el-breadcrumb-item
                >发表时间：{{ newData.created_at }}</el-breadcrumb-item
              >
            </el-breadcrumb>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <index-icons
              @clickMark="clickMark"
              :activityId="newData.activity_id"
              :workId="newData.id"
              :goodsnum="marks"
              :commentnum="comment"
              :looknum="views"
              :ShowComment="ShowComment"
            ></index-icons>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="zp_text">
      <div class="box">
        <div class="text">{{ newData.text }}</div>
        <div class="demo-image__preview">
          <el-image
            v-for="(v, index) in srcList"
            :src="v"
            :key="index"
            fit="contain"
            :preview-src-list="srcList"
          >
          </el-image>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IndexIcons from "@/components/Icons";
export default {
  name: "ImgDetails",
  components: {
    IndexIcons
  },
  props: ["imgDetails", "activityId", "ShowComment"],
  data() {
    return {
      newData: "",
      marks: "",
      comment: "",
      views: "",
      imgnum: "",
      url: "",
      srcList: []
    };
  },
  watch: {
    //正确给 newData 赋值的 方法
    imgDetails: function(newVal, oldVal) {
      this.newData = newVal; //newVal即是chartData
      console.log("监听props改变");
      console.log(newVal);
      this.srcList = newVal.image;
      console.log(this.srcList);
      this.imgnum = newVal.image.length;
      this.marks = newVal.mark;
      this.comment = newVal.comment;
      this.views = newVal.views;
    }
  },
  computed: {
    label_name() {
      let id = this.activityId;
      if (+id === 426) {
        return `参赛者单位`;
      } else {
        return "参赛机构";
      }
    }
  },
  methods: {
    clickMark() {
      this.marks = parseInt(this.marks) + 1;
    }
  }
};
</script>
<style scoped>
.box {
  width: 100%;
  background: white;
  background: #ffffff;
  border-radius: 10px;
  text-align: center;
}
.center {
  width: 1200px;
  margin: 20px auto;
}
.center .title {
  height: 26px;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin: 30px 0px;
}

.grid-content >>> .comment_icons {
  margin: 0px;
  width: 100%;
  text-align: right !important;
}

.zp_text {
  width: 1200px;
  height: auto;
  background: #ffffff;
  border-radius: 10px;
  margin: 20px 0px;
  padding: 40px 50px;
  box-sizing: border-box;
}

.text {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
video {
  width: 1080px;
  height: 540px;
  margin: 20px auto;
}
img {
  margin: 20px 0px;
}
.el-image {
  margin: 0px 10px;
  width: 200px;
  height: 150px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/workdetails/components/img.vue